import { render, staticRenderFns } from "./RevisePhone.vue?vue&type=template&id=17c9e5c2&scoped=true&"
import script from "./RevisePhone.vue?vue&type=script&lang=js&"
export * from "./RevisePhone.vue?vue&type=script&lang=js&"
import style0 from "./RevisePhone.vue?vue&type=style&index=0&id=17c9e5c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c9e5c2",
  null
  
)

export default component.exports